import { useSiteMetadata } from "@/hooks/use-site-metadata"
import React from "react"

export const SEO: React.FC<{ children?: React.ReactNode, title?: string, description?: string, pathname?: string, seoImage?: string }> = ({ title, description, pathname, children, seoImage }) => {

  const { title: defaultTitle, description: defaultDescription, image, siteUrl, twitterUsername } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: `${siteUrl}${seoImage || image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />

      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />

      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:type" content="website" />

      <link rel="icon" href="/favicon.png" />
      <script
        dangerouslySetInnerHTML={{
          __html: `
!function(t){var k="ko",i=(window.globalKoalaKey=window.globalKoalaKey||k);if(window[i])return;var ko=(window[i]=[]);["identify","track","removeListeners","on","off","qualify","ready"].forEach(function(t){ko[t]=function(){var n=[].slice.call(arguments);return n.unshift(t),ko.push(n),ko}});var n=document.createElement("script");n.async=!0,n.setAttribute("src","https://cdn.getkoala.com/v1/pk_4dcf0e9ebbe53a9476bfe3ac3a90f041b0c5/sdk.js"),(document.body || document.head).appendChild(n)}();
          `,
        }}
      />
      <script id="vtag-ai-js" async src="https://r2.leadsy.ai/tag.js" data-pid="12131pOR01uPI1NQp" data-version="062024"></script>
      {children}
    </>
  )
}